import api from "./api";
import env from "../config/environment";
import { lgpdConsentBody } from "./lgpd-consent-body";

export const lgpdEndpoint = (businessProcess, cpf) =>
  `/lgpd/v1/consentimentos/processo-negocio/${businessProcess}/pessoas/${cpf}`;

export const getLgpdConsent = (businessProcess, subprocess, cpf) =>
  api.get(
    lgpdEndpoint(businessProcess, cpf),
    {},
    {
      "macro-processo-negocio": env.MACRO_PROCESS_CODE,
      "sub-processo-negocio": subprocess,
    }
  );

export const postLgpdConsent = (
  businessProcess,
  cpf,
  propsalId,
  lgpdConsent,
  subprocess
) => {
  const endpoint = lgpdEndpoint(businessProcess, cpf);
  const data = lgpdConsentBody(propsalId, cpf, subprocess, lgpdConsent);

  return api.post(endpoint, data);
};
